Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var require_runtime = require('./_virtual/_rolldown/runtime.cjs');
var _module_federation_runtime = require("@module-federation/runtime");
var _module_federation_runtime_helpers = require("@module-federation/runtime/helpers");
_module_federation_runtime_helpers = require_runtime.__toESM(_module_federation_runtime_helpers);
//#region src/init.ts
function init(param) {
    var webpackRequire = param.webpackRequire;
    var _webpackRequire_federation = webpackRequire.federation, initOptions = _webpackRequire_federation.initOptions, runtime = _webpackRequire_federation.runtime, sharedFallback = _webpackRequire_federation.sharedFallback, bundlerRuntime = _webpackRequire_federation.bundlerRuntime, libraryType = _webpackRequire_federation.libraryType;
    if (!initOptions) throw new Error("initOptions is required!");
    var treeShakingSharePlugin = function treeShakingSharePlugin() {
        return {
            name: "tree-shake-plugin",
            beforeInit (args) {
                var userOptions = args.userOptions, origin = args.origin, registeredOptions = args.options;
                var version = userOptions.version || registeredOptions.version;
                if (!sharedFallback) return args;
                var currentShared = userOptions.shared || {};
                var shared = [];
                Object.keys(currentShared).forEach((sharedName)=>{
                    (Array.isArray(currentShared[sharedName]) ? currentShared[sharedName] : [
                        currentShared[sharedName]
                    ]).forEach((sharedArg)=>{
                        shared.push([
                            sharedName,
                            sharedArg
                        ]);
                        if ("get" in sharedArg) {
                            sharedArg.treeShaking ||= {};
                            sharedArg.treeShaking.get = sharedArg.get;
                            sharedArg.get = bundlerRuntime.getSharedFallbackGetter({
                                shareKey: sharedName,
                                factory: sharedArg.get,
                                webpackRequire,
                                libraryType,
                                version: sharedArg.version
                            });
                        }
                    });
                });
                var hostGlobalSnapshot = _module_federation_runtime_helpers.default.global.getGlobalSnapshotInfoByModuleInfo({
                    name: origin.name,
                    version
                });
                if (!hostGlobalSnapshot || !("shared" in hostGlobalSnapshot)) return args;
                Object.keys(registeredOptions.shared || {}).forEach((pkgName)=>{
                    registeredOptions.shared[pkgName].forEach((sharedArg)=>{
                        shared.push([
                            pkgName,
                            sharedArg
                        ]);
                    });
                });
                var patchShared = (pkgName, shared)=>{
                    var shareSnapshot = hostGlobalSnapshot.shared.find((item)=>item.sharedName === pkgName);
                    if (!shareSnapshot) return;
                    var treeShaking = shared.treeShaking;
                    if (!treeShaking) return;
                    var secondarySharedTreeShakingName = shareSnapshot.secondarySharedTreeShakingName, secondarySharedTreeShakingEntry = shareSnapshot.secondarySharedTreeShakingEntry, treeShakingStatus = shareSnapshot.treeShakingStatus;
                    if (treeShaking.status === treeShakingStatus) return;
                    treeShaking.status = treeShakingStatus;
                    if (secondarySharedTreeShakingEntry && libraryType && secondarySharedTreeShakingName) treeShaking.get = ()=>_async_to_generator._(function*() {
                            var shareEntry = yield (0, _module_federation_runtime.getRemoteEntry)({
                                origin,
                                remoteInfo: {
                                    name: secondarySharedTreeShakingName,
                                    entry: secondarySharedTreeShakingEntry,
                                    type: libraryType,
                                    entryGlobalName: secondarySharedTreeShakingName,
                                    shareScope: "default"
                                }
                            });
                            yield shareEntry.init(origin, __webpack_require__.federation.bundlerRuntime);
                            return shareEntry.get();
                        })();
                };
                shared.forEach((param)=>{
                    var _param = _sliced_to_array._(param, 2), pkgName = _param[0], sharedArg = _param[1];
                    patchShared(pkgName, sharedArg);
                });
                return args;
            }
        };
    };
    initOptions.plugins ||= [];
    initOptions.plugins.push(treeShakingSharePlugin());
    return runtime.init(initOptions);
}
//#endregion
exports.init = init; //# sourceMappingURL=init.cjs.map
